import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Linkbubble = ({ social }) => {
  return (
    <div className="link">
      <FontAwesomeIcon icon={social} />
    </div>
  );
};

export default Linkbubble;
